<template>
  <div class="menu-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <div v-if="item.uuid==''" >
                <i className="fa fa-align-justify"></i><strong>{{ $t('common.create') }}</strong>
              </div>
              <div v-if="item.uuid!=''" >
                <i className="fa fa-align-justify"></i><strong>{{ $t('common.edit') }}</strong>
              </div>
            </div>
            <b-form class="row" v-if="item != null">
              <b-col cols="6">
                <b-form-group v-bind:label="$t('user.email')" :label-cols="4" :horizontal="true">
                  <b-form-input
                    class="form-control border-radius-4px"
                    v-model="item.email"
                    :state="!$v.item.email.$invalid"
                    :aria-describedby="'name-feedback'" />
                  <b-form-invalid-feedback :id="'name-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group v-bind:label="$t('user.name')" :label-cols="4" :horizontal="true">
                  <b-form-input
                    class="form-control border-radius-4px"
                    v-model="item.name"
                    :state="!$v.item.name.$invalid"
                    :aria-describedby="'contact_name-feedback'" />
                  <b-form-invalid-feedback :id="'contact_name-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group v-bind:label="$t('user.phone')" :label-cols="4" :horizontal="true">
                  <b-form-input
                    class="form-control border-radius-4px"
                    v-model="item.phone"
                    :state="!$v.item.phone.$invalid"
                    :aria-describedby="'phone-feedback'" />
                  <b-form-invalid-feedback :id="'phone-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group v-bind:label="$t('user.client_reference')" :label-cols="4" :horizontal="true">
                  <multiselect v-model="item.clients"
                               :placeholder="$t('user.search_client')"
                               :hideSelected="true"
                               label="name" track-by="code" :options="clients_option" :multiple="true" :taggable="true"
                               v-bind:selectLabel="$t('menu.select_label')"
                               v-bind:deselectLabel="$t('menu.select_remove')"
                               v-bind:selectedLabel="$t('menu.selected')"
                               :class="[ (!item.clients.length) ? 'border border-danger border-radius-4px' : '']"
                  >
                  </multiselect>
                  <div v-show="!item.clients.length" class="xs-flex xs-items-center xs-mb-5" style="color: #f86c6b">
                    <span class="text-alert">{{ $t('message.required_filed') }}</span>
                  </div>
                </b-form-group>

                <b-form-group v-bind:label="$t('user.roles')" :label-cols="4" :horizontal="true">
                  <multiselect v-model="item.roles"
                               :placeholder="$t('user.search_roles')"
                               :hideSelected="true"
                               label="name" track-by="code" :options="roles_options" :multiple="true" :taggable="true"
                               v-bind:selectLabel="$t('menu.select_label')"
                               v-bind:deselectLabel="$t('menu.select_remove')"
                               v-bind:selectedLabel="$t('menu.selected')"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-row>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('user.active')" label-cols="5" :horizontal="true">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.status" :value="1" :uncheckedValue="0"/>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="hide">
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('user.phdv_member')" label-cols="5" :horizontal="true">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.is_admin" :value="true" :uncheckedValue="false"/>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12">
                <b-form-group v-bind:label="$t('user.outlets')" :label-cols="2" :horizontal="true">
                  <multiselect v-model="item.outlets"
                               :placeholder="$t('user.outlets')"
                               :hideSelected="true"
                               label="name" track-by="code" :options="outlets_option.hasOwnProperty($session.get('lang')) ?  outlets_option[$session.get('lang')] : []"
                               :multiple="true"
                               :taggable="true"
                               group-values="items"
                               group-label="group"
                               :group-select="true"
                               :close-on-select="false"
                               v-bind:selectLabel="$t('menu.select_label')"
                               v-bind:deselectLabel="$t('menu.select_remove')"
                               v-bind:selectedLabel="$t('menu.selected')"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-form>
            <div slot="footer">
              <router-link :to="{ name: 'user_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pull-right pl-3 pr-3" v-on:click="saveUser" :disabled="checkSubmit()" > {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, email } from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'
  let vm = null

  const CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const NUMBER = '0123456789'
  const SPECIAL = '~!@#$%^&*()_+-=[];/.,{}<>?:'
  const MIN_DROP = 2

  export default {
    name: 'UsersForm',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      Tables,
      cSwitch,
      Multiselect
    },
    data: function () {
      return {
        outlets_option: {},
        clients_option: [],
        client_name: '',
        load_more: 10,
        current_page: 0,
        total_page: 0,
        roles_options: [],
        user_id: this.uuid,
        item: {
          id: '',
          uuid: '',
          name: '',
          email: '',
          phone: '',
          password: '',
          clients: [],
          roles: [],
          outlets: [],
          outlet_codes: [],
          status: 1,
          is_admin: false
        }
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          required
        },
        phone: {
          required
        },
        email: {
          required,
          email
        }
      }
    },
    methods: {
      checkSubmit: function () {
        return vm.$v.item.$invalid ? true : !vm.item.clients.length ? true : false
      },
      generatePassword() {
        const upperIndex = Math.floor(Math.random() * (CHARACTERS.length - MIN_DROP))
        const upperCase = CHARACTERS.slice(upperIndex, upperIndex + MIN_DROP).toUpperCase()
        const lowerIndex = Math.floor(Math.random() * (CHARACTERS.length - MIN_DROP))
        const lowerCase = CHARACTERS.slice(lowerIndex, lowerIndex + MIN_DROP).toLowerCase()
        const numberIndex = Math.floor(Math.random() * (NUMBER.length - MIN_DROP))
        const number = NUMBER.slice(numberIndex, numberIndex + MIN_DROP)
        const specialIndex = Math.floor(Math.random() * (SPECIAL.length - MIN_DROP))
        const special = SPECIAL.slice(specialIndex, specialIndex + MIN_DROP)
        
        return [...`${upperCase}${lowerCase}${number}${special}`].sort(()=> Math.random() - .5).join('');
      },
      isJSON: function (str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      updateStoresForUser() {
        let stores = []
        for (let i in vm.item.outlets) {
          stores.push(vm.item.outlets[i].code)
        }
        let params = {
          user_id: vm.item.id,
          store_code: stores
        }
        vm.axios.tenant.updateStoresForUser(params, function(response){
          vm.$router.push({name: 'user_list'})
        }, error => {
          console.log('error', error)
        })
      },
      saveUser () {
        // call an API to save client information
        // check create or update
        if (vm.uuid === 'create' || vm.uuid == undefined) {
          let getValueRoles = []
          let getClients = []
          for (var i = 0; i <= vm.item.roles.length; i++) {
            if (typeof vm.item.roles[i] !== 'undefined') {
              getValueRoles.push(vm.item.roles[i].code)
            }
          }
          for (var i = 0; i <= vm.item.clients.length; i++) {
            if (typeof vm.item.clients[i] !== 'undefined') {
              getClients.push(vm.item.clients[i].code)
            }
          }
          vm.item.roles = getValueRoles
          vm.item.clients = getClients
          delete vm.item['uuid']
          vm.axios.tenant.createUser(vm.item, function(response){
            vm.item.id = response.data.data.item.id
            vm.updateStoresForUser()
          })
        }
        else {
          delete vm.item.password
          delete vm.item.permission
          delete vm.item.created_at
          delete vm.item.updated_at
          let rolesChange = []
          let clientChange = []
          for (var j = 0; j <= vm.item.roles.length; j++) {
            if (typeof vm.item.roles[j] !== 'undefined') {
              rolesChange.push(vm.item.roles[j].code)
            }
          }
          for (var j = 0; j <= vm.item.clients.length; j++) {
            if (typeof vm.item.clients[j] !== 'undefined') {
              clientChange.push(vm.item.clients[j].code)
            }
          }
          // vm.item.clients = clientsChange
          vm.item.roles = rolesChange
          vm.item.clients = clientChange
          vm.axios.tenant.updateUser(vm.uuid, vm.item, function(response){
            vm.updateStoresForUser()
          }, error => {
            console.log('error', error)
          })
        }
      },
      getOutletList (cb) {
        vm.$bus.$emit('loading', 'block');
        vm.axios.outlet.getOutletList('?limit=9999999999999',{

          }, function(response){
            if (response.status === 200) {
              let outletDataList = response.data.data.items
              let langs = vm.$store.getters.languages
              for (let l in langs) {
                vm.outlets_option[langs[l]] = []
                let options = {}
                for (let i = 0; i <= outletDataList.length; i++) {
                  if (typeof outletDataList[i] !== 'undefined') {
                    let ownerCode = '____'
                    let ownerName = '________'

                    if (outletDataList[i].owner_code != null || outletDataList[i].owner_code == '') {
                      ownerCode = outletDataList[i].owner_code
                    }

                    if (outletDataList[i].owner_name != null || outletDataList[i].owner_name == '') {
                      ownerName = outletDataList[i].owner_name
                    }

                    if (options[outletDataList[i].owner_code] == null) {
                      options[outletDataList[i].owner_code] = {
                        group: ownerCode + ' - ' + ownerName,
                        items: []
                      }
                    }

                    options[outletDataList[i].owner_code].items.push({name: outletDataList[i].code + ' - ' + outletDataList[i].name[langs[l]], code: outletDataList[i].code})
                  }
                }

                for (let o in options) {
                  vm.outlets_option[langs[l]].push(options[o])
                }
                vm.$forceUpdate('outlets_option')
              }
            }
            vm.$bus.$emit('loading', 'none')
            cb()
          }
        )
      }
    },
    created: function () {
      vm = this
      vm.item.password = vm.generatePassword()
      let langs = vm.$store.getters.languages
      for (let l in langs) {
        vm.outlets_option[langs[l]] = []
      }
    },
    mounted: function () {
      // get list clients
      vm.axios.tenant.getClientList('limit=500', respone => {
        if (respone.status === 200) {
            let clientDataList = respone.data.data.items
            for (var i = 0; i <= clientDataList.length; i++) {
              if (typeof clientDataList[i] !== 'undefined') {
                vm.clients_option.push({name: clientDataList[i].name, code: clientDataList[i].uuid})
              }
            }
        }
      }, error => {
        console.log('error', error)
      })
      // get list roles
      vm.axios.user.getListRoles('ignore_limit=1', respone => {
        if (respone.status === 200) {
          let roleDataList = respone.data.data.items
            for (var i = 0; i <= roleDataList.length; i++) {
              if (typeof roleDataList[i] !== 'undefined') {
                vm.roles_options.push({name: roleDataList[i].name, code: roleDataList[i].slug})
              }
            }
        }
      }, error => {
        console.log('error', error)
      })
      if (vm.uuid == 'create' || vm.uuid == undefined) {
        vm.getOutletList()
      }
      else{
        vm.axios.user.getUserDetail(vm.uuid, function (response) {
          let item = JSON.parse(JSON.stringify(response.data.data.item))
          let clients = []
          for (var i = 0; i <= item.clients.length; i++) {
            if (typeof item.clients[i] !== 'undefined') {
              clients.push({code: item.clients[i].uuid, name: item.clients[i].name})
            }
          }
          item.clients = clients

          for (var i = 0; i <= item.roles.length; i++) {
            if (typeof item.roles[i] !== 'undefined') {
              item.roles[i].code = item.roles[i].slug
              delete item.roles[i].uuid
            }
          }
          item.outlets = []
          vm.item = item

          vm.getOutletList(function () {
            if (item.user_stores.length >= 0) {
              for (let i in item.user_stores[0].store_code) {
                for (let j in vm.outlets_option[vm.$session.get('lang')]) {
                  for (let h in vm.outlets_option[vm.$session.get('lang')][j].items) {
                    if (vm.outlets_option[vm.$session.get('lang')][j].items[h].code == item.user_stores[0].store_code[i]) {
                      item.outlets.push(vm.outlets_option[vm.$session.get('lang')][j].items[h])
                      break
                    }
                  }
                }
              }
            }
          })
        })
      }
    }
  }
</script>
<style scoped>
  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }

  .input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3e515b;
    text-align: center;
    white-space: nowrap;
    background-color: #f8f9fa;
    border: 1px solid #e4e5e6;
  }

  .custom-checkbox {
    padding-left: 0px;
  }

  .col-6{
    float: left;
  }

  .menu-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .xs-flex i {
    float: left;
    margin-right: 5px;
  }
  .text-alert {
    font-size: 80%;
  }
  .typo-l7 {
    font-size: 80%;
  }
  .xs-text-green-dark {
    color: #00a67c;
  }
  .xs-text-red {
    color: red;
  }
  .xs-text-gray {
    color: #999580;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>




// WEBPACK FOOTER //
// src/views/admin/user/BaseForm.vue